import { AvatarProps } from '@material-ui/core';
import { IconSize } from '.';

export enum AvatarSize {
  'XS' = 32,
  'SM' = 48,
  'MD' = 64,
  'LG' = 96,
}

export interface CustomAvatar {
  mode: 'icon' | 'image';
  variant: AvatarProps['variant'];
  imagePath: string;
  colorMask?: string;
  fallback: JSX.Element | string;
  size?: { container: AvatarSize; icon?: IconSize };
  bgcolor?: string;
}
